/* eslint-disable array-callback-return */
import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import {
  AppStateService,
  ConfigService,
  DomainService,
  ErroMessages,
  IDomain,
  IErroMessages,
  IRoute,
  KEY_CREDENTIAIS,
  RouterItemPg,
  STATE,
  TOKEN_KEYS,
  TokenService,
  User,
  UserSettingsService
} from 'viggo-sistemas-core-web';
import { MenuToolBarItem } from 'viggo-sistemas-core-web/modules/toolbar/components/slide-menu-right/slide-menu-right.component';

import { FastMenuService } from '@app/global services/fast-menu-service/fast-menu-service';

import { HttpErrorResponse } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { ValidadorSettingsUser } from '@app/shared/utils/validar_settings_user';
import build from '../../../../package.json';
import { CustomMenuService } from '../../global services';

export const KEY_PRIMEIROS_PASSOS = 'PRIMEIROS_PASSOS';
export const KEY_REFAZER_PRIMEIROS_PASSOS = 'REFAZER_PASSOS';
export const KEY_PULOU_PRIMEIROS_PASSOS = 'PULOU_PASSOS';
export const KEY_NEW_VERSION = 'NEW_VERSION';
export const KEY_VERSION = 'VERSION';

interface buildMenu {
  label: string;
  items: RouterItemPg[];
  routerLink?: string[];
  icon?: string;
  precedence?: number;
}
@Component({
  selector: 'app-logged',
  templateUrl: './logged.component.html',
  styleUrls: ['./logged.component.scss']
})
export class LoggedComponent implements OnDestroy, OnInit {
  // default
  public appName: string;
  public logoToolBar = 'assets/images/WoundCareSys-icone.png';
  public firstContact = true;
  public loading = false;
  requisitions = 0;
  public empresa: IDomain;

  public menuItem = [] as buildMenu[];

  menuFast = [] as MenuToolBarItem[];

  menuProfile = [] as MenuToolBarItem[];
  // primeng

  // actions layout
  topbarMenuActive: boolean;
  menuActive: boolean;
  staticMenuDesktopInactive: boolean;
  mobileMenuActive: boolean;
  menuClick: boolean;
  mobileTopbarActive: boolean;
  topbarRightClick: boolean;
  topbarItemClick: boolean;
  activeTopbarItem: string;
  documentClickListener: () => void;
  configActive: boolean;
  configClick: boolean;
  rightMenuActive: boolean;
  menuHoverActive = false;
  searchClick = false;
  search = false;
  currentInlineMenuKey: string;
  inlineMenuActive: any[] = [];
  inlineMenuClick: boolean;

  // PrimeNG config
  topbarTheme = 'pink';
  menuTheme = 'light';
  layoutMode = 'light';
  menuMode = 'slim';
  inlineMenuPosition = 'bottom';
  inputStyle = 'filled';
  ripple = true;
  isRTL = false;
  isActive = false;
  itemMenu = false;
  usaCaixa = false;
  usaFiscal = false;
  actionJump = false;
  actionRebuild = false;
  isUserDefault = false;
  isUserAdmin = false;

  constructor(
    private renderer: Renderer2,
    private tokenService: TokenService,
    private matSnackBar: MatSnackBar,
    private matDialog: MatDialog,
    public router: Router,
    protected menu: CustomMenuService,
    protected fastMenuService: FastMenuService,
    protected configService: ConfigService,
    protected domainService: DomainService,
    protected userSettingsService: UserSettingsService,
    protected appState: AppStateService
  ) {
    this.appName = 'WoundCareSys';
    localStorage.setItem(TOKEN_KEYS.URL_API, configService.backendURL);
    localStorage.setItem(KEY_VERSION, build.version);
    let user = this.tokenService.getUser();
    this.isUserAdmin =
      user.roles.find(rl => rl.name.toUpperCase() === 'ADMIN') !== undefined;
    this.isUserDefault =
      user.roles.find(rl => rl.name.toUpperCase() === 'SYSADMIN') !== undefined;
    this.tokenService.refreshUser(user);
    if (user) {
      user.settings = new ValidadorSettingsUser(
        user.settings,
        user.roles.find(rl => rl.name.toUpperCase() === 'SYSADMIN') !==
          undefined
      ).getUserSettingsBody(user.settings) as any;
      this.tokenService.refreshUser(user);
    }
    this.tokenService.refreshUser(user);
  }

  isDark: boolean;
  toggleTheme() {
    this.isDark = !this.isDark;
  }

  ngOnInit() {
    this.appState.setAppState(STATE.READY);
    this.isDark = false;
    localStorage.setItem(KEY_PRIMEIROS_PASSOS, 'true');
    this.loading = true;
    const domain = this.tokenService.getDomain();
    // if (domain.name === 'default') {
    //   this.requisitions = 0;
    //   this.firstContact = false;
    // } else if (
    //   domain.settings['config_inicial'].ultimo_passo === 'FINALIZADO' ||
    //   domain.settings['config_inicial'].ultimo_passo === 'FINALIZADO_PARCIAL'
    // ) {
    //   this.requisitions = 0;
    //   this.firstContact = false;
    // }
    // if (
    //   !localStorage.getItem(KEY_PULOU_PRIMEIROS_PASSOS) &&
    //   !this.actionJump &&
    //   domain.settings['config_inicial'].pulou_passo
    // )
    //   localStorage.setItem(
    //     KEY_PULOU_PRIMEIROS_PASSOS,
    //     domain.settings['config_inicial'].pulou_passo.toString()
    //   );
    // if (
    //   !localStorage.getItem(KEY_REFAZER_PRIMEIROS_PASSOS) &&
    //   !this.actionRebuild &&
    //   !domain.settings['config_inicial'].pulou_passo
    // )
    //   localStorage.setItem(
    //     KEY_REFAZER_PRIMEIROS_PASSOS,
    //     (!domain.settings['config_inicial'].pulou_passo).toString()
    //   );

    // if (!this.isUserDefault) {
    //   this.router.events
    //     // .pipe(
    //     //   filter(event => {
    //     //     return event instanceof NavigationEnd || event instanceof Scroll;
    //     //   })
    //     // )
    //     .subscribe((event: NavigationEnd | Scroll) => {
    //       let router = {} as NavigationEnd | NavigationSkipped;
    //       if (event instanceof Scroll) router = event.routerEvent;
    //       this.requisitions += 1;
    //       const domain = this.tokenService.getDomain();
    //       if (domain) {
    //         // if (
    //         //   !(
    //         //     domain.settings['config_inicial'].ultimo_passo ===
    //         //       'FINALIZADO' ||
    //         //     domain.settings['config_inicial'].ultimo_passo ===
    //         //       'FINALIZADO_PARCIAL'
    //         //   ) &&
    //         //   (localStorage.getItem(KEY_PRIMEIROS_PASSOS) === 'true' ||
    //         //     localStorage.getItem(KEY_REFAZER_PRIMEIROS_PASSOS) ===
    //         //       'true') &&
    //         //   (router.url === '/workspace' ||
    //         //     router.url === '/' ||
    //         //     router.url === '/primeiros_passos') &&
    //         //   localStorage.getItem(KEY_PULOU_PRIMEIROS_PASSOS) !== 'true' &&
    //         //   this.requisitions === 1
    //         // ) {
    //         //   this.requisitions = 0;
    //         //   this.firstContact = true;
    //         //   this.loading = false;
    //         //   this.empresa = domain;
    //         //   this.initMenuToolBar();
    //         //   this.router.navigate(['/primeiros_passos']);
    //         // } else if (
    //         //   (domain.settings['config_inicial'].ultimo_passo ===
    //         //     'FINALIZADO' ||
    //         //     domain.settings['config_inicial'].ultimo_passo ===
    //         //       'FINALIZADO_PARCIAL' ||
    //         //     localStorage.getItem(KEY_PULOU_PRIMEIROS_PASSOS) === 'true') &&
    //         //   localStorage.getItem(KEY_PRIMEIROS_PASSOS) === 'true' &&
    //         //   this.menuItem.length === 0
    //         // ) {
    //         //   this.requisitions = 0;
    //         //   this.firstContact = false;
    //         //   this.verificarDadosEmpresa();
    //         // } else if (
    //         //   router.url === '/erro-integracoes-externas' &&
    //         //   this.requisitions === 1
    //         // ) {
    //         //   this.requisitions = 0;
    //         //   this.firstContact = false;
    //         //   this.loading = false;
    //         //   this.empresa = domain;
    //         //   this.initMenuToolBar();
    //         //   this.router.navigate(['/workspace']);
    //         // } else {
    //         this.loading = false;
    //         this.empresa = domain;
    //         this.initMenuToolBar();
    //         // this.verificarDadosEmpresa();
    //         // }
    //       }
    //     });
    //   // this.verificarDadosEmpresa();
    // } else {
    this.loading = false;
    this.verificarDadosEmpresa();
    // }
  }

  /**
   * Baixa as informações de domain
   */
  protected verificarDadosEmpresa(): void {
    this.domainService
      .getEntity(
        this.tokenService.getDomain().id,
        'application,addresses.municipio,addresses.pais'
      )
      .subscribe(
        dadosempresa => {
          // if (
          //   this.isUserDefault ||
          //   dadosempresa.settings['config_inicial'].ultimo_passo ===
          //     'FINALIZADO' ||
          //   dadosempresa.settings['config_inicial'].ultimo_passo ===
          //     'FINALIZADO_PARCIAL' ||
          //   localStorage.getItem(KEY_PULOU_PRIMEIROS_PASSOS) === 'true'
          // ) {
          this.empresa = dadosempresa;
          this.loading = false;
          this.firstContact = false;
          if (localStorage.getItem(KEY_PULOU_PRIMEIROS_PASSOS) !== 'true') {
            localStorage.removeItem(KEY_PRIMEIROS_PASSOS);
            localStorage.removeItem('UFICMS_ID');
            localStorage.removeItem('dialogOpened');
            localStorage.removeItem('dialogConcluidedOpened');
          }
          this.menuActive = !(this.isOverlay() && !this.isMobile());
          if (!this.itemMenu) this.initMenuItem();
          // this.initMenuItem();
          this.initMenuToolBar();
          // } else if (
          //   this.isUserAdmin &&
          //   (dadosempresa.settings['config_inicial'].ultimo_passo !==
          //     'FINALIZADO' ||
          //     dadosempresa.settings['config_inicial'].ultimo_passo !==
          //       'FINALIZADO_PARCIAL' ||
          //     localStorage.getItem(KEY_REFAZER_PRIMEIROS_PASSOS) === 'true') &&
          //   localStorage.getItem(KEY_PULOU_PRIMEIROS_PASSOS) !== 'true'
          // ) {
          //   localStorage.setItem(KEY_PRIMEIROS_PASSOS, 'true');
          //   this.empresa = dadosempresa;
          //   this.loading = false;
          //   this.firstContact = true;
          //   this.initMenuToolBar();
          //   this.router.navigate(['/primeiros_passos']);
          // } else {
          //   this.empresa = dadosempresa;
          //   this.loading = false;
          //   this.firstContact = true;
          //   this.initMenuToolBar();
          //   this.router.navigate(['/primeiros_passos']);
          // }
        },
        (err: HttpErrorResponse) => {
          this.displayError(err, true);
        }
      );
  }

  protected initMenuToolBar() {
    this.menuProfile = [
      {
        title: 'Informações de usuário',
        icon: 'pi pi-user',
        action: true
      },
      {
        title: 'Alterar senha',
        icon: 'pi pi-lock',
        action: true
      },
      {
        title: 'Sair',
        icon: 'pi pi-power-off',
        action: true
      }
    ] as MenuToolBarItem[];
    if (
      this.tokenService.isLoggedIn() &&
      this.tokenService.getRoutes().length !== 0 &&
      this.menuFast.length === 0 &&
      !this.firstContact
    ) {
      this.fastMenuService.onCreateFastMenu().subscribe(fastMenuIt => {
        this.menuFast = fastMenuIt;
      });
    }
  }

  /**
   * Valida as rotas do usuário
   * @param routes
   * @param url_name
   * @returns
   */
  verificarRotasDeAcesso(routes: IRoute[], url_name: string): IRoute[] {
    if (routes && routes.length > 0 && url_name) {
      return routes.filter(r => new RegExp(`^${url_name}`).test(r.url));
    }
  }

  /**
   * Valida se as rotas do usuário são equivalentes ao pacote de rotas do fiscal
   * @param routesAuthorization
   * @param action
   * @param params
   * @param url_name
   * @returns
   */
  validarAdicao(
    routesAuthorization: IRoute[],
    action: string,
    params = '',
    url_name: string
  ): boolean {
    if (routesAuthorization && routesAuthorization.length > 0) {
      const url_return = routesAuthorization.find(
        route => route.url === url_name && route.method === action
      );
      return !!url_return;
    }
  }

  /**
   * Verifica se preenche ou nao o menu de user
   * @returns
   */
  verificarMenuUser() {
    const action = 'POST' as string;
    const params = '' as string;
    const url_users = '/users' as string;

    const routesAuthorization = this.verificarRotasDeAcesso(
      this.tokenService.getRoutes(),
      url_users
    ) as IRoute[];

    const permitirMenuUser = this.validarAdicao(
      routesAuthorization,
      action,
      params,
      url_users
    );
    return permitirMenuUser;
  }

  protected initMenuItem() {
    this.itemMenu = true;
    this.loading = true;
    // mount menu routes
    this.menu.onCreateMenuPrimeNg().subscribe(
      menuItem => {
        if (!this.isMobile()) {
          const prevMenu = this.menuItem;
          // const index = this.menuItem.findIndex(m => m.label.includes('Menu'));
          // if (index >= 0) {
          //   prevMenu.splice(index, 1);
          //   this.menuItem = prevMenu;
          // }
          var menuUser = {} as buildMenu;
          menuItem.map((item, index) => {
            if (item) {
              if (item.label === 'Segurança') {
                if (this.verificarMenuUser())
                  menuUser = {
                    label: item.label,
                    icon: item.icon,
                    routerLink: item.routerLink,
                    items: item.items
                  };
              } else
                this.menuItem.push({
                  label: item.label,
                  icon: item.icon,
                  routerLink: item.routerLink,
                  items: item.items,
                  precedence: index > 0 ? index - 1 : index
                });
            }
            if (
              Object.keys(menuUser).length !== 0 &&
              index + 1 === menuItem.length
            ) {
              this.menuItem.push({ ...menuUser, precedence: index });
            }
          });
        } else {
          this.menuMode = 'overlay';
          this.menuItem.push({
            label: 'Menu',
            icon: 'pi pi-fw pi-play',
            items: []
          });
          menuItem.map(item => {
            this.menuItem[0].items.push({
              label: item.label,
              icon: item.icon,
              routerLink: item.routerLink,
              items: item.items,
              idElement: item.label
            });
          });
        }
      },
      () => {},
      () => {
        this.loading = false;
        if (!this.tokenService.isMenuItemLs())
          this.router.navigate(['/workspace']);
      }
    );
  }

  ngAfterViewInit() {
    // hides the horizontal submenus or top menu if outside is clicked
    this.documentClickListener = this.renderer.listen('body', 'click', () => {
      if (!this.topbarItemClick) {
        this.activeTopbarItem = null;
        this.topbarMenuActive = false;
      }

      if (!this.menuClick && (this.isHorizontal() || this.isSlim())) {
        this.menu.reset();
      }

      if (this.configActive && !this.configClick) {
        this.configActive = false;
      }

      if (!this.menuClick) {
        if (this.mobileMenuActive) {
          this.mobileMenuActive = false;
        }

        if (this.isOverlay()) {
          this.menuActive = false;
        }

        this.menuHoverActive = false;
        this.unblockBodyScroll();
      }

      if (!this.searchClick) {
        this.search = false;
      }

      if (
        this.inlineMenuActive[this.currentInlineMenuKey] &&
        !this.inlineMenuClick
      ) {
        this.inlineMenuActive[this.currentInlineMenuKey] = false;
      }

      this.inlineMenuClick = false;
      this.searchClick = false;
      this.configClick = false;
      this.topbarItemClick = false;
      this.topbarRightClick = false;
      this.menuClick = false;
    });
  }

  onMenuButtonClick(event) {
    this.menuActive = !this.menuActive;
    this.topbarMenuActive = false;
    this.topbarRightClick = true;
    this.menuClick = true;

    if (this.isDesktop()) {
      this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
    } else {
      this.mobileMenuActive = !this.mobileMenuActive;
      if (this.mobileMenuActive) {
        this.blockBodyScroll();
      } else {
        this.unblockBodyScroll();
      }
    }

    event.preventDefault();
  }

  onTopbarMobileButtonClick(event) {
    this.mobileTopbarActive = !this.mobileTopbarActive;
    event.preventDefault();
  }

  onMenuClick(event) {
    this.menuClick = true;

    if (
      this.inlineMenuActive[this.currentInlineMenuKey] &&
      !this.inlineMenuClick
    ) {
      this.inlineMenuActive[this.currentInlineMenuKey] = false;
    }
  }

  blockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.add('blocked-scroll');
    } else {
      document.body.className += ' blocked-scroll';
    }
  }

  unblockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.remove('blocked-scroll');
    } else {
      document.body.className = document.body.className.replace(
        new RegExp(
          `(^|\\b)${'blocked-scroll'.split(' ').join('|')}(\\b|$)`,
          'gi'
        ),
        ' '
      );
    }
  }

  isDesktop() {
    return window.innerWidth > 991;
  }

  isMobile() {
    return window.innerWidth <= 991;
  }

  isStatic() {
    return this.menuMode === 'static';
  }

  isHorizontal() {
    return this.menuMode === 'horizontal';
  }

  isSlim() {
    return this.menuMode === 'slim';
  }

  isOverlay() {
    return this.menuMode === 'overlay';
  }

  ngOnDestroy() {
    if (this.documentClickListener) {
      this.documentClickListener();
    }
  }

  get isLoggedIn() {
    return this.tokenService.isLoggedIn();
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const txtMsg = showDefaultMsg
      ? `Identificamos o erro ${err.status} - ${err.statusText} no processamento dos dados!`
      : err.error;
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      matDialog: this.matDialog,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      vlMsgDefault: txtMsg,
      dialogComponent: ConfirmDialogComponent,
      dialogData: {
        config: {
          data: {
            title: 'Aviso',
            bodyMessage: txtMsg,
            icon: 'pi pi-fw pi-info-circle text-orange-500 mb-2 mr-2',
            singleBtn: true
          } as ConfirmDialogData,
          width: '500px'
        }
      }
    } as IErroMessages);
    errorMsg.checkError();
  }

  public updateVersion() {
    this.matDialog
      .open(ConfirmDialogComponent, {
        data: {
          bodyMessage:
            'Parece que você está utilizando uma versão desatualizada! \n Deseja realizar atualização do sistema agora ou mais tarde?',
          title: 'Atualização do sistema',
          icon: 'pi pi-fw pi-refresh text-primary mr-2',
          icon_color: 'primary',
          labelCloseButton: 'Deixar para depois',
          labelConfirmButton: 'Atualizar agora',
          breakline: true
        } as ConfirmDialogData,
        disableClose: true,
        panelClass: ['custom-container'],
        width: '500px'
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.onLogOut();
        }
      });
  }

  showFabVersion() {
    return localStorage.getItem(KEY_NEW_VERSION) === 'true';
  }

  public onLogOut() {
    if (this.tokenService.isLoggedIn()) {
      var user = this.tokenService.getUser() as User;
      user = {
        ...user,
        settings: {
          ...user.settings,
          primeiro_acesso: false,
          version: {
            ...user.settings['version'],
            web_version: localStorage.getItem(KEY_VERSION)
          }
        } as any
      };
      this.userSettingsService.update(user.settings, user.id).subscribe(
        vl => {
          this.tokenService.onLogout().subscribe(
            () => {
              const credentials = localStorage.getItem(KEY_CREDENTIAIS);
              const URL_API = localStorage.getItem(TOKEN_KEYS.URL_API);
              localStorage.clear();
              localStorage.setItem(KEY_CREDENTIAIS, credentials);
              localStorage.setItem(TOKEN_KEYS.URL_API, URL_API);
              this.router.navigate(['/auth/login']);
            },
            (err: HttpErrorResponse) => {
              if (err && err.error) this.displayError(err);
            },
            () => {
              this.router.navigate(['/auth/login']).finally(() => {
                if (!this.tokenService.isLoggedIn()) window.location.reload();
              });
            }
          );
        },
        (err: HttpErrorResponse) => {
          this.displayError(err);
        }
      );
    }
  }
}
